module.exports = __webpack_public_path__ + "static/media/logo-mv.53dbc32e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/logo-mv.svg
// module id = 576
// module chunks = 1